import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "navbar-title" }
const _hoisted_2 = { class: "navbar-version" }
const _hoisted_3 = { class: "d-flex align-center mr-2" }
const _hoisted_4 = { class: "user-info" }
const _hoisted_5 = { key: 0 }

import { computed, inject, onMounted, ref } from 'vue';
import { VERSION } from '@/constants';
import TranslationService from '@/locale/translation.service';
import { useTranslationStore } from '@/stores/translation';
import { useAppStateStore } from '@/stores/appState';
import { useAccountStore } from '@/stores/account';
import UserProfileDialog from '@/venit/user/profile/user-profile-dialog.vue';
import Cart from '@/venit/components/cortona-venit/components/cart/Cart.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'app-header',
  setup(__props) {

const translationService = inject<() => TranslationService>('translationService')!;
const translationStore = useTranslationStore();
const appStateStore = useAppStateStore();
const accountStore = useAccountStore();

const version = VERSION && VERSION != 'UNKNOWN' ? 'v' + VERSION : '';
const profileDialogOpen = ref(false);

const languages = computed(() => translationStore.languages);
const currentLanguage = computed(() => translationStore.currentLanguage);
const username = computed(() => accountStore.account ? accountStore.account.email : '');
const authenticated = computed(() => accountStore.authenticated);
const isOrgUser = computed(() => authenticated.value && accountStore.account?.userType === 'ORGANIZATION_USER');
const accountSwitched = computed(() => accountStore.accountSwitched);
const realUserName = computed(() => accountStore.realUserName);

const changeLanguage = (newLanguage: string): void => {
  translationService().refreshTranslation(newLanguage);
};

const isActiveLanguage = (key: string): boolean => {
  return key === translationStore.currentLanguage;
};

const toggleDrawer = (): void => {
  appStateStore.setDrawer(!appStateStore.drawer);
};

onMounted(() => {
  translationService().refreshTranslation(currentLanguage.value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    id: "core-app-bar",
    app: "",
    color: "primary",
    height: "88"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar_nav_icon, { onClick: toggleDrawer }),
      _createVNode(_component_v_toolbar_title, { class: "font-weight-light align-self-center" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('global.title')), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(version)), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("div", null, _toDisplayString(username.value), 1 /* TEXT */),
          (accountSwitched.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "[" + _toDisplayString(realUserName.value) + "]", 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createVNode(_component_v_btn, {
          icon: "",
          size: "40",
          to: "/",
          exact: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-home", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }),
        (isOrgUser.value)
          ? (_openBlock(), _createBlock(Cart, { key: 0 }))
          : _createCommentVNode("v-if", true),
        (authenticated.value)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              icon: "",
              size: "40",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (profileDialogOpen.value = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-account-circle", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        (authenticated.value)
          ? (_openBlock(), _createBlock(UserProfileDialog, {
              key: 2,
              modelValue: profileDialogOpen.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profileDialogOpen).value = $event))
            }, null, 8 /* PROPS */, ["modelValue"]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" menu z jezykami "),
        _createVNode(_component_v_menu, {
          location: "bottom left",
          transition: "slide-y-transition"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              class: "toolbar-items",
              icon: "",
              size: "40"
            }, props), {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(currentLanguage.value), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { density: "compact" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (value, key) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: `lang-${key}`,
                        onClick: ($event: any) => (changeLanguage(key)),
                        class: _normalizeClass({ active: isActiveLanguage(key) })
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(value.name), 1 /* TEXT */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "class"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})